import OfficeBrandTable from "./OfficeBrandTable";

const OfficeBrand = () => {
  return (
    <>
      <OfficeBrandTable />
    </>
  );
};

export default OfficeBrand;
